class TextInput
{
    constructor(element, metaKeys = [])
    {
        console.log("TextInput.js - Creating new text input: ", element);
        this.element = element;
        this.metaKeys = metaKeys;
        this.value = "";
        this.timer = null;
    }

    addMetaKey(metaKey)
    {
        if (!this.metaKeys.includes(metaKey) && typeof metaKey === "string") {
            this.metaKeys.push(metaKey);
        }
    }

    /**
     * Watch the value of the text input and call the callback when it changes
     *
     * @param callback - the callback to call when the value changes
     */
    watchValue(callback)
    {
        console.log("TextInput.js - Watching value: ", this.element);

        this.element.addEventListener("keydown", (e) => {
            clearTimeout(this.timer);

            this.timer = setTimeout(() => {
                console.log("TextInput.js - Updating search value: ", e.target.value);
                this.value = e.target.value;
                callback(this.value);
            }, 500);
        });
    }

    getValue()
    {
        return this.value;
    }
}

export default TextInput;
